import { Grid, TextField, FormHelperText, MenuItem, Tooltip, InputAdornment } from '@material-ui/core';
import { MuiPickersUtilsProvider, DatePicker } from '@material-ui/pickers';
import React, { useContext, useEffect, useState } from 'react';
import { Controller } from 'react-hook-form';
import AuthContext from './../../authContext';
import { checkHourisPast } from './../../utils/helpers';
import disablePrevDateByHour from '../../utils/Date/disablePrevDateByHour'
import classes from './../../pages/createOrder/index.module.scss'
import warehousesRepository from 'client-sdk/src/Repository/warehouses-repository';
import JalaliUtils from '@date-io/jalaali';
import getTomorrowDate from '../../utils/Date/getTomorrowDate';
import env from "client-sdk/src/enviroments/enviroment"
import Icon from '@mdi/react';
import { mdiInformationOutline } from '@mdi/js';
import theme from '../../theme';

const deliveryTimes = {
    fulfillmentService: [
        {
            value: '09-12',
            label: '9 الی 12',
            disable: "9"
        },
        {
            value: '12-15',
            label: '12 الی 15',
            disable: "12"
        },
        {
            value: '15-18',
            label: '15 الی 18',
            disable: "15"
        },
        {
            value: '18-21',
            label: '18 الی 21',
            disable: "18"
        },
    ],
    courier: [
        {
            value: '09-15',
            label: '9 الی 15',
            disable: "0"
        },
        {
            value: '15-21',
            label: '15 الی 21',
            disable: "15"
        }
    ],
    vip: [
        {
            value: '08-10',
            label: '8 الی 10',
            disable: "08"
        },
        {
            value: '09-11',
            label: '9 الی 11',
            disable: "09"
        },
        {
            value: '10-12',
            label: '10 الی 12',
            disable: "10"
        },
        {
            value: '11-13',
            label: '11 الی 13',
            disable: "11"
        },
        {
            value: '12-14',
            label: '12 الی 14',
            disable: "12"
        },
        {
            value: '13-15',
            label: '13 الی 15',
            disable: "13"
        },
        {
            value: '14-16',
            label: '14 الی 16',
            disable: "14"
        },
        {
            value: '15-17',
            label: '15 الی 17',
            disable: "15"
        },
        {
            value: '16-18',
            label: '16 الی 18',
            disable: "16"
        },
    ]
}

const validateNumber = (value) => {
    if (!value) {
        return true
    }

    const pattern = /^[0-9]+$/;
    return pattern.test(value)
}


function OrderInputs(props: any) {
    const authContext = useContext(AuthContext);
    const { form, cod, isFulfillmentService, deliveryLocationType, editMode } = props
    const {
        errors,
        setValue,
        getValues,
        register,
        control,
        reset,
        watch
    } = form
    const values = getValues();
    const [originOptions, setOriginOptions] = useState<any>([]);

    useEffect(() => {
        // fetchWarehouses().then(res => setOriginOptions(res));
        setOriginOptions(env.warehouses)
        setValue("origin", env.warehouses[0].id)
    }, []);

    useEffect(() => {
        if (isFulfillmentService || deliveryLocationType) {
            setValue("customerProvince", "تهران")
            setValue("customerCity", "تهران")
        } else {
            setValue("customerProvince", "")
            setValue("customerCity", "")
        }
    }, [isFulfillmentService, deliveryLocationType]);

    useEffect(() => {
        if (values.deliveryDate || !editMode) {
            deliveryTypeChange()
        }
    }, [watch('deliveryType')]);

    useEffect(() => {
        if (values.deliveryDate) {
            setValue('deliveryTime', '');
        }
    }, [values.deliveryDate]);

    const handleDisableTime = (hour: number) => {
        return (
            checkHourisPast(hour, watch("deliveryDate"))
        );
    };

    const handleDeliveryTime = () => {
        let time: any[] = values.deliveryType == "COURIER" ? deliveryTimes.courier : deliveryTimes.vip

        return (
            time.map(el => (
                <MenuItem
                    disabled={handleDisableTime(el.disable)}
                    value={el.value}
                    data-cy="firstTime"
                >
                    {el.label}
                </MenuItem>
            ))
        )
    }

    const checkDisableOrderTplType = () => {
        if (isFulfillmentService || deliveryLocationType) {
            setValue("orderTplType", "RONAD")
            return true;
        }
        if (values.deliveryType !== "COURIER") {
            setValue("orderTplType", "RONAD")
            return true
        }
        return false
    }

    const calculateMinDate = () => {
        if (isFulfillmentService && values.deliveryType == "COURIER") {
            return getTomorrowDate()
        }
        if (isFulfillmentService && values.deliveryType == "VIP") {
            return disablePrevDateByHour(12)
        }
        if (deliveryLocationType && values.deliveryType == "COURIER") {
            return disablePrevDateByHour(10)
        }
        if (deliveryLocationType && values.deliveryType == "VIP") {
            return disablePrevDateByHour(16)
        }
        if (isFulfillmentService && deliveryLocationType) {
            return disablePrevDateByHour(8)
        }
        if (values.deliveryType == "COURIER") {
            return disablePrevDateByHour(10)
        }
        if (values.deliveryType == "VIP") {
            return disablePrevDateByHour(16)
        }
        if (values.deliveryType == "VVIP") {
            return disablePrevDateByHour(16)
        }
        return disablePrevDateByHour(10);
    }

    const deliveryTypeChange = () => {
        setValue('deliveryDate', calculateMinDate())
        setValue('deliveryTime', '')
    };

    return (
        <Grid container item md={8} spacing={3} style={{ margin: 0 }}>
            <Grid item xs={12} md={3} lg={3}>
                <div className={classes.item}>
                    <div style={{ width: '100%' }}>
                        <Controller
                            name="trackingCode"
                            label="* کد پیگیری"
                            control={control}
                            rules={{
                                required: true,
                                pattern: /^[A-Za-z\d\-_]+$/,
                                minLength: 3,
                            }}
                            as={
                                <TextField
                                    type="search"
                                    variant="outlined"
                                    fullWidth
                                    id="trackingCode"
                                    name="trackingCode"
                                    // label="کدپیگیری"
                                    error={
                                        !!errors.trackingCode && !!errors.trackingCode
                                    }
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <Tooltip title="کد دلخواه و منحصر به فرد برای هر سفارش که می‌توانید از طریق آن سفارش خود را در مراحل مختلف پیگیری نمایید">
                                                    <Icon
                                                        path={mdiInformationOutline}
                                                        size={1}
                                                        color={theme.palette.primary.main}
                                                        className={classes.icon}
                                                    />
                                                </Tooltip>
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                            }
                        />
                        <FormHelperText error focused>
                            {errors?.trackingCode?.type === 'required' &&
                                'کدپیگیری الزامی میباشد'}
                        </FormHelperText>
                        <FormHelperText error focused>
                            {errors?.trackingCode?.type === 'minLength' &&
                                'کد پیگیری حداقل 3 کاراکتر می باشد'}
                        </FormHelperText>
                    </div>
                </div>
            </Grid>
            <Grid
                item
                xs={12}
                sm={6}
                md={4}
                lg={3}
                alignItems="flex-end"
            >
                <div className={classes.item}>
                    <div style={{ width: '100%' }} data-cy="deliveryType">
                        <Controller
                            style={{ width: '100%' }}
                            control={control}
                            name="deliveryType"
                            label="* نوع سفارش "
                            rules={{
                                required: true,
                            }}
                            as={
                                <TextField
                                    type="search"
                                    variant="outlined"
                                    select
                                    fullWidth
                                    error={errors.deliveryType && true}
                                >
                                    <MenuItem data-cy="COURIER" value={'COURIER'}>
                                        عادی
                                    </MenuItem>
                                    <MenuItem data-cy="VIP" value={'VIP'} disabled={cod}>
                                        ویژه
                                    </MenuItem>
                                    {authContext.user.partnerId == "14" && <MenuItem data-cy="VVIP" value={'VVIP'}>
                                        فوری
                                    </MenuItem>}
                                </TextField>
                            }
                        />
                        <FormHelperText error focused>
                            {errors?.deliveryType &&
                                'نوع سفارش الزامی میباشد'}
                        </FormHelperText>
                    </div>
                </div>
            </Grid>
            <Grid
                item
                xs={12}
                sm={6}
                md={4}
                lg={3}
                alignItems="flex-end"
            >
                <div className={classes.item}>
                    <div style={{ width: '100%' }} data-cy="orderTplType">
                        <Controller
                            style={{ width: '100%' }}
                            control={control}
                            name="orderTplType"
                            label=" * ناوگان حمل  "
                            rules={{
                                required: true,
                            }}
                            as={
                                <TextField
                                    type="search"
                                    variant="outlined"
                                    select
                                    fullWidth
                                    disabled={checkDisableOrderTplType()}
                                    error={errors.orderTplType && true}
                                >
                                    <MenuItem
                                        data-cy="RONAD"
                                        value={'RONAD'}
                                    >
                                        پیک
                                    </MenuItem>
                                    <MenuItem
                                        data-cy="EXPRESS_POST"
                                        value={'EXPRESS_POST'}
                                    >
                                        پست پیشتاز
                                    </MenuItem>
                                    <MenuItem data-cy="NEDEX" value={'NEDEX'}>
                                        ندکس
                                    </MenuItem>
                                    <MenuItem data-cy="CHAPAR" value={'CHAPAR'}>
                                        چاپار
                                    </MenuItem>
                                    <MenuItem data-cy="TAPIN_POST" value={'TAPIN_POST'}>
                                        تاپین
                                    </MenuItem>
                                    <MenuItem data-cy="TAPIN_KETAB" value={'TAPIN_KETAB'}>
                                        تاپین کتاب
                                    </MenuItem>
                                </TextField>
                            }
                        />
                        <FormHelperText error focused>
                            {errors?.orderTplType &&
                                'ناوگان حمل الزامی میباشد'}
                        </FormHelperText>
                    </div>
                </div>
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3}>
                <div className={classes.item}>
                    <div style={{ width: '100%' }} data-cy="startPoint">
                        <Controller
                            style={{ width: '100%' }}
                            control={control}
                            name="origin"
                            label="انبار مبدا"
                            rules={{
                                required: true,
                            }}
                            as={
                                <TextField
                                    select
                                    fullWidth
                                    variant="outlined"
                                    style={{ width: '100%' }}
                                    disabled={values.deliveryType == ""}
                                    error={errors.origin && true}
                                >
                                    {authContext.user.partnerId == "14" && <MenuItem
                                        data-cy={'start' + 696}
                                        key="696"
                                        value="696"
                                    >
                                        انبار داخلی
                                    </MenuItem>}
                                    {originOptions?.length > 0 ? (
                                        originOptions.map((item: any, i: number) => (
                                            <MenuItem
                                                data-cy={'start' + i}
                                                key={item.id}
                                                value={item.id}
                                            >
                                                {item.name}
                                            </MenuItem>
                                        ))
                                    ) : (
                                        <MenuItem value="">در حال بارگزاری</MenuItem>
                                    )}
                                </TextField>}
                        />
                        <FormHelperText error focused>
                            {errors.origin && 'مبدا سفارش الزامی میباشد'}
                        </FormHelperText>
                    </div>
                </div>
            </Grid>
            <Grid item xs={12} sm={6} md={3} lg>
                <MuiPickersUtilsProvider
                    utils={JalaliUtils}
                    locale="fa"
                >
                    <Controller
                        rules={{ required: true }}
                        name="deliveryDate"
                        control={control}
                        as={
                            <DatePicker
                                inputVariant="outlined"
                                id="deliveryDate"
                                name="deliveryDate"
                                label="* تاریخ تحویل سفارش"
                                format="jYYYY/jMM/jDD"
                                minDate={calculateMinDate()}
                                fullWidth
                                disablePast
                                autoOk
                                okLabel="تأیید"
                                cancelLabel="لغو"
                                defaultValue={null}
                                disabled={values.deliveryType == ""}
                                value={values.deliveryDate}
                                onChange={() => setValue('deliveryTime', '')}
                                error={errors.hasOwnProperty('deliveryDate')}
                                helperText={
                                    errors.deliveryDate &&
                                    errors.deliveryDate.message
                                }
                            />
                        }
                    />
                    <FormHelperText error focused>
                        {errors.deliveryDate &&
                            'تاریخ تحویل سفارش الزامی میباشد'}
                    </FormHelperText>
                </MuiPickersUtilsProvider>
            </Grid>
            <Grid item xs={12} sm={6} md={3} lg>
                <Controller
                    rules={{ required: true }}
                    style={{ width: '100%' }}
                    control={control}
                    name="deliveryTime"
                    label="* بازه تحویل سفارش"
                    as={
                        <TextField
                            variant="outlined"
                            select
                            fullWidth
                            disabled={values.deliveryType == ""}
                            error={
                                !!errors.deliveryTime && !!errors.deliveryTime
                            }
                        >
                            {handleDeliveryTime()}
                        </TextField>
                    }
                />
                <FormHelperText error focused>
                    {errors?.deliveryTime &&
                        ' بازه تحویل سفارش الزامی میباشد'}
                </FormHelperText>
            </Grid>
            <Grid
                item
                xs={12}
                sm={4}
                md={3}
                lg
            >
                <Controller
                    name="orderValue"
                    label="ارزش سفارش (ریال)"
                    control={control}
                    rules={{
                        required: false,
                        validate: validateNumber
                    }}
                    as={
                        <TextField
                            type="search"
                            variant="outlined"
                            fullWidth
                            disabled={values.deliveryType == ""}
                            id="orderValue"
                            name="orderValue"
                            label="ارزش سفارش (ریال)"
                            error={
                                !!errors.orderValue && !!errors.orderValue
                            }
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <Tooltip title="مقدار وارد شده به عنوان ارزش سفارش جهت بیمه ارسال اعمال میگردد">
                                            <Icon
                                                path={mdiInformationOutline}
                                                size={1}
                                                color={theme.palette.primary.main}
                                                className={classes.icon}
                                            />
                                        </Tooltip>
                                    </InputAdornment>
                                ),
                            }}
                        />
                    }
                />
                <FormHelperText error focused>
                    {errors.orderValue?.type === 'required' &&
                        'ارزش سفارش الزامی میباشد'}
                </FormHelperText>
                <FormHelperText error focused>
                    {errors?.orderValue?.type === 'validate' &&
                        'لطفا عدد انگلیسی وارد کنید'}
                </FormHelperText>
            </Grid>
            {cod && <Grid item xs={12} md={3} lg>
                <Controller
                    name="cost"
                    label="مبلغ فاکتور(ریال)"
                    control={control}
                    rules={{
                        required: cod,
                        validate: validateNumber
                    }}
                    as={
                        <TextField
                            type="text"
                            variant="outlined"
                            fullWidth
                            id="cost"
                            name="cost"
                            error={!!errors.cost && !!errors.cost}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <Tooltip title="مقدار وارد شده به عنوان مبلغ نهایی از گیرنده سفارش دریافت میگردد">
                                            <Icon
                                                path={mdiInformationOutline}
                                                size={1}
                                                className={classes.icon}
                                                color={theme.palette.primary.main}
                                            />
                                        </Tooltip>
                                    </InputAdornment>
                                ),
                            }}
                        />
                    }
                />
                <FormHelperText error focused>
                    {errors?.cost?.type === 'required' &&
                        'مبلغ فاکتور الزامی میباشد'}
                </FormHelperText>
                <FormHelperText error focused>
                    {errors.cost?.type === 'validate' &&
                        'لطفا عدد انگلیسی وارد کنید'}
                </FormHelperText>
            </Grid>}
        </Grid>
    )
}

export default OrderInputs;